import React from 'react';
import { Popover, PopoverBody } from 'reactstrap';

const PopoverCommon = (props) => {
    return (
        <Popover placement="top" isOpen={props.isOpen} target={props.target}
            toggle={props.toggle} style={styles.popoverStyle}>
            <PopoverBody>
                <p>{props.textContent}</p>
            </PopoverBody>
        </Popover>
    )
}

export default PopoverCommon;

const styles = {
    popoverStyle: {
        padding: '12px 6px 0px 6px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/PopoverCommon.js